module.exports = "/_next/static/images/HeroBackground-8721467cebd387df8271ec9ef07d221a.webp";